// extracted by mini-css-extract-plugin
module.exports = {"login_page_container":"LoginPage_login_page_container__2V8V8","bold-medium":"LoginPage_bold-medium__pNm6m"};